import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import { type AblyTokenType } from 'hb-react/shared/hooks/useSubscribeToAblyChannel/types';
import { ably_token_path, backoffice_network_ably_token_path } from 'hb-routes';

type UseAblyAuthUrl = (tokenType: AblyTokenType) => string | null;

// Ably is not available in PO right now
export const useAblyAuthUrl: UseAblyAuthUrl = (tokenType) => {
  const { currentAdmin, currentUser, currentNetworkId } =
    useDefaultAppContexts();

  // Context detection: currentAdmin is only set in backoffice, currentUser in frontoffice
  const inBO = !!(currentAdmin && currentNetworkId);
  const inFO = !!currentUser;

  if (inBO && currentNetworkId) {
    return backoffice_network_ably_token_path(currentNetworkId, {
      type: tokenType,
      format: 'json',
    });
  }

  if (inFO) {
    return ably_token_path({ type: tokenType, format: 'json' });
  }

  // ably is not available in PO for the moment
  return null;
};
